<div class="ac-page">

  <!-- Header -->
  <div class="ac-page-header">
    <div class="ac-page-header__left">
      <div class="ac-page-header__icon"><mat-icon>format_list_bulleted</mat-icon></div>
      <div>
        <h1 class="ac-page-header__title">Plan de cuentas</h1>
        <p class="ac-page-header__sub">Consulta, edita y gestiona las cuentas contables</p>
      </div>
    </div>
    <div class="ac-page-header__actions">
      <button mat-flat-button class="ac-btn-add" (click)="create()">
        <mat-icon>add</mat-icon> Nueva cuenta
      </button>
    </div>
  </div>

  <!-- Toolbar de búsqueda -->
  <div class="ac-toolbar">
    <div class="ac-toolbar__fields">
      <mat-form-field appearance="outline" style="min-width:260px">
        <mat-label>Filtrar cuentas</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput type="text" [formControl]="textSearchFormControl"
          (keydown.tab)="keyDownTabPress($event)"
          (keydown.enter)="keyDownTabAndEnterPress($event)">
      </mat-form-field>
    </div>
    <div class="ac-toolbar__actions">
      <button mat-flat-button class="ac-btn-primary" (click)="filterAccounts()">
        <mat-icon>search</mat-icon> Buscar
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div class="ac-loading" *ngIf="isLoadingResults">
    <div class="ac-loading__icon"><mat-icon>format_list_bulleted</mat-icon></div>
    <div class="ac-loading__dots"><span></span><span></span><span></span></div>
    <p class="ac-loading__text">Cargando cuentas…</p>
  </div>

  <!-- Tabla -->
  <div class="ac-table-wrap" [hidden]="isLoadingResults">
    <div class="table-responsive">
      <table mat-table [dataSource]="data" class="table w-100">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let row" (click)="ledger(row.id, row.name, row.number)" style="cursor:pointer;color:#1a1d23;font-weight:500">
            {{ row.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef>Cuenta</th>
          <td mat-cell *matCellDef="let row" (click)="ledger(row.id, row.name, row.number)" style="cursor:pointer;font-variant-numeric:tabular-nums;color:#e3fd64;font-weight:600">
            {{ row.number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Tipo</th>
          <td mat-cell *matCellDef="let row">{{ row.type }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" style="text-align:right">
            <button mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="actionRowClicked(row)">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>

        <mat-menu #actionsMenu="matMenu">
          <button mat-menu-item (click)="extracto()">
            <mat-icon>file_download</mat-icon><span>Extracto Excel</span>
          </button>
          <button mat-menu-item (click)="mayor()">
            <mat-icon>menu</mat-icon><span>Libro mayor</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="edit(actionRowClickedUid)">
            <mat-icon>edit</mat-icon><span>Editar</span>
          </button>
          <button mat-menu-item (click)="delete(actionRowClickedUid)" style="color:#dc2626">
            <mat-icon style="color:#dc2626">delete</mat-icon><span>Eliminar</span>
          </button>
        </mat-menu>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <mat-paginator [length]="resultsLength" [pageSize]="pageSizeDefault"></mat-paginator>
  </div>

</div>
